import { useMemo } from "react";
import { Modal } from "../../components/Modal";
import { DataTable, type Column } from "../../components/DataTable";
import type { LogReviewServerNode } from "../../types/logReview";

/**
 * Minimal shape needed by the popup — satisfied by both the main
 * `LogReviewRow` and the Insights `LogInsightRow`.
 */
export interface LogReviewServersRow {
  changeRequestId: string;
  serverNodes: LogReviewServerNode[];
}

export interface LogReviewServersModalProps {
  open: boolean;
  row: LogReviewServersRow | null;
  onOpenChange: (open: boolean) => void;
  isLoading?: boolean;
}

/**
 * Per-CR "Servers/Nodes" popup opened from the Servers/Nodes count link.
 * Lists each team and its servers / CIs.
 */
export const LogReviewServersModal = ({
  open,
  row,
  onOpenChange,
  isLoading = false,
}: LogReviewServersModalProps) => {
  const columns = useMemo<Column<LogReviewServerNode>[]>(
    () => [
      { key: "team", align: "left", header: "Team", headerAlign: "center" },
      { key: "serverCis", align: "left", header: "Servers/CIs", headerAlign: "center" },
    ],
    [],
  );

  return (
    <Modal
      open={open}
      onClose={() => onOpenChange(false)}
      title={row ? `CR No: ${row.changeRequestId} - Servers/Nodes` : "Servers/Nodes"}
    >
      <DataTable<LogReviewServerNode>
        columns={columns}
        data={row?.serverNodes ?? []}
        loading={isLoading}
        emptyMessage="No Data Available"
        rowKey={(_, index) => index}
      />
    </Modal>
  );
};
